import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from 'lib/request/api';
import type { EntityResponse } from 'types/api-responses';

/**
 * The name of the entity page a document was opened from, for its breadcrumb.
 * A breadcrumb has a fallback label, so a failed load is not retried.
 * @param {string} href The entity page, e.g. /entities/1564.
 * @return {object} The query, its data the entity's name.
 */
export function useEntityName(href: string) {
  return useQuery(
    queryOptions({
      queryKey: ['documents', 'referrer-entity', href],
      queryFn: ({ signal }) =>
        api.get(href.replace(/^\//, ''), { signal }).json<EntityResponse>(),
      select: (entity) => entity.name,
      retry: false,
    })
  );
}
